<a class="lightbox-trigger" (click)="openLightbox()">
  <div class="image-placeholder">
      <mat-icon svgIcon="play"></mat-icon>
      <img width="100%" [src]="image">
  </div>
  <div class="text-placeholder">
      <span [innerHTML]="placeholder"></span>
  </div>
</a>
